/**
 * @generated SignedSource<<5c4c0b1bdd853a24076090dd034238a5>>
 * @relayHash d717910a34c78e88e5f0cf6fd7986948
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 4b39a08b8b7d33aa63b6ede55e32463c741290c08d610e26910e19f75689ca9d

import type { ConcreteRequest } from 'relay-runtime';
export type ConfluenceAnalyticsAccountType = "AGENT" | "USER" | "%future added value";
export type ConfluencePageAnalyticsActorType = "AGENTS" | "ALL" | "PEOPLE" | "%future added value";
export type SitePermissionType = "ANONYMOUS" | "APP" | "EXTERNAL" | "INTERNAL" | "JSD" | "%future added value";
export type usePageViewsAnalyticsViewersWithActorTypeQuery$variables = {
  actorType?: ConfluencePageAnalyticsActorType | null;
  contentId: string;
  engageTimeThreshold?: number | null;
  isPrivacyModeEnabled?: boolean | null;
  limit?: number | null;
};
export type usePageViewsAnalyticsViewersWithActorTypeQuery$data = {
  readonly contentAnalyticsViewsByUser: {
    readonly pageViews: ReadonlyArray<{
      readonly accountType: ConfluenceAnalyticsAccountType | null;
      readonly agentType: string | null;
      readonly confluenceUser: {
        readonly permissionType: SitePermissionType | null;
      } | null;
      readonly isEngaged: boolean | null;
      readonly lastVersionViewedNumber: number | null;
      readonly lastVersionViewedUrl: string | null;
      readonly lastViewedAt: string;
      readonly relatedUser: {
        readonly displayName: string | null;
        readonly id: string | null;
        readonly photos: ReadonlyArray<{
          readonly isPrimary: boolean | null;
          readonly value: string | null;
        } | null> | null;
      } | null;
      readonly relatedUserAccountId: string | null;
      readonly userProfile: {
        readonly displayName: string | null;
        readonly id: string | null;
        readonly isActive: boolean | null;
        readonly photos: ReadonlyArray<{
          readonly isPrimary: boolean | null;
          readonly value: string | null;
        } | null> | null;
      } | null;
      readonly views: number;
    }>;
  } | null;
  readonly singleContent: {
    readonly id: string | null;
    readonly subType: string | null;
    readonly version: {
      readonly number: number | null;
    } | null;
  } | null;
};
export type usePageViewsAnalyticsViewersWithActorTypeQuery = {
  response: usePageViewsAnalyticsViewersWithActorTypeQuery$data;
  variables: usePageViewsAnalyticsViewersWithActorTypeQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "actorType"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "engageTimeThreshold"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isPrivacyModeEnabled"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "limit"
},
v5 = {
  "kind": "ScalarField",
  "name": "id"
},
v6 = {
  "args": [
    {
      "kind": "Variable",
      "name": "id",
      "variableName": "contentId"
    }
  ],
  "concreteType": "Content",
  "kind": "LinkedField",
  "name": "singleContent",
  "plural": false,
  "selections": [
    (v5/*: any*/),
    {
      "kind": "ScalarField",
      "name": "subType"
    },
    {
      "concreteType": "Version",
      "kind": "LinkedField",
      "name": "version",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "number"
        }
      ]
    }
  ]
},
v7 = [
  {
    "kind": "Variable",
    "name": "actorType",
    "variableName": "actorType"
  },
  {
    "kind": "Variable",
    "name": "contentId",
    "variableName": "contentId"
  },
  {
    "kind": "Variable",
    "name": "engageTimeThreshold",
    "variableName": "engageTimeThreshold"
  },
  {
    "kind": "Variable",
    "name": "isPrivacyModeEnabled",
    "variableName": "isPrivacyModeEnabled"
  },
  {
    "kind": "Variable",
    "name": "limit",
    "variableName": "limit"
  }
],
v8 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v9 = {
  "concreteType": "AtlassianUserPhoto",
  "kind": "LinkedField",
  "name": "photos",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "value"
    },
    {
      "kind": "ScalarField",
      "name": "isPrimary"
    }
  ]
},
v10 = {
  "concreteType": "ContentAnalyticsPageViewInfo",
  "kind": "LinkedField",
  "name": "pageViews",
  "plural": true,
  "selections": [
    {
      "concreteType": "AtlassianUser",
      "kind": "LinkedField",
      "name": "userProfile",
      "plural": false,
      "selections": [
        (v5/*: any*/),
        (v8/*: any*/),
        (v9/*: any*/),
        {
          "kind": "ScalarField",
          "name": "isActive"
        }
      ]
    },
    {
      "concreteType": "ConfluenceUser",
      "kind": "LinkedField",
      "name": "confluenceUser",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "permissionType"
        }
      ]
    },
    {
      "kind": "ScalarField",
      "name": "accountType"
    },
    {
      "kind": "ScalarField",
      "name": "agentType"
    },
    {
      "kind": "ScalarField",
      "name": "relatedUserAccountId"
    },
    {
      "concreteType": "AtlassianUser",
      "kind": "LinkedField",
      "name": "relatedUser",
      "plural": false,
      "selections": [
        (v5/*: any*/),
        (v8/*: any*/),
        (v9/*: any*/)
      ]
    },
    {
      "kind": "ScalarField",
      "name": "views"
    },
    {
      "kind": "ScalarField",
      "name": "lastViewedAt"
    },
    {
      "kind": "ScalarField",
      "name": "lastVersionViewedNumber"
    },
    {
      "kind": "ScalarField",
      "name": "lastVersionViewedUrl"
    },
    {
      "kind": "ScalarField",
      "name": "isEngaged"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "name": "usePageViewsAnalyticsViewersWithActorTypeQuery",
    "selections": [
      (v6/*: any*/),
      {
        "args": (v7/*: any*/),
        "concreteType": "ContentAnalyticsViewsByUser",
        "kind": "LinkedField",
        "name": "contentAnalyticsViewsByUser",
        "plural": false,
        "selections": [
          (v10/*: any*/)
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v4/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "usePageViewsAnalyticsViewersWithActorTypeQuery",
    "selections": [
      (v6/*: any*/),
      {
        "args": (v7/*: any*/),
        "concreteType": "ContentAnalyticsViewsByUser",
        "kind": "LinkedField",
        "name": "contentAnalyticsViewsByUser",
        "plural": false,
        "selections": [
          (v10/*: any*/),
          (v5/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "cacheID": "d717910a34c78e88e5f0cf6fd7986948",
    "id": "4b39a08b8b7d33aa63b6ede55e32463c741290c08d610e26910e19f75689ca9d",
    "metadata": {},
    "name": "usePageViewsAnalyticsViewersWithActorTypeQuery",
    "operationKind": "query",
    "text": "query usePageViewsAnalyticsViewersWithActorTypeQuery($contentId:ID!,$limit:Int,$engageTimeThreshold:Int,$isPrivacyModeEnabled:Boolean,$actorType:ConfluencePageAnalyticsActorType){singleContent(id:$contentId){id,subType,version{number}},contentAnalyticsViewsByUser(contentId:$contentId,limit:$limit,engageTimeThreshold:$engageTimeThreshold,isPrivacyModeEnabled:$isPrivacyModeEnabled,actorType:$actorType){pageViews{userProfile{id,displayName,photos{value,isPrimary},isActive},confluenceUser{permissionType},accountType,agentType,relatedUserAccountId,relatedUser{id,displayName,photos{value,isPrimary}},views,lastViewedAt,lastVersionViewedNumber,lastVersionViewedUrl,isEngaged},id}}"
  }
};
})();

(node as any).hash = "eb5f809bd8367e8c7bdf5326f35bc263";

export default node;
